import { all } from "redux-saga/effects";
import actionWatcher from "@src/components/Tabs/Overview/store/saga";
import courseContentSaga from "@src/components/Tabs/Content/store/saga";
import courseLiveClassSaga from "@src/components/Tabs/LiveClasses/store/sagas";
import tabListSaga from "@src/components/UIElements/TabBar/store/saga";
import upcomingClassesSaga from "@src/components/BottomSheets/components/UpcomingClassModal/store/sagas";
import announcementsSaga from "@src/components/Tabs/Announcements/store/saga";
import physicalShipmentSaga from "@src/components/PhysicalAddress/store/sagas";
// function* rootSaga() {
//   yield all([actionWatcher()]);

function* rootSaga() {
  // To prevent api calls from the server
  if(typeof window){
    yield all([
      courseContentSaga(),
      actionWatcher(),
      courseLiveClassSaga(),
      tabListSaga(),
      upcomingClassesSaga(),
      announcementsSaga(),
      physicalShipmentSaga(),
    ]);
  }
}

export default rootSaga;
